import Footer from './Footer'
import footerHeight from './_footerHeight'

export { footerHeight }

export default Footer
